import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { isEmptyWhereClause } from '@modules/common/utils';
import {
  DEFAULT_COMPARE_FILTER_A_NAME,
  DEFAULT_COMPARE_FILTER_B_NAME,
} from '@modules/quantify/constants';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { alpha } from '@mui/material';

interface CompareFilterDefinitionInfoProps {
  shouldHideTooltips?: boolean;
  compareField: 'A' | 'B';
}

export const CompareFilterDefinitionInfo = ({
  shouldHideTooltips,
  compareField,
}: CompareFilterDefinitionInfoProps) => {
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);
  const whereClauseA = useQuantifyStore(({ query }) => query?.whereClause);

  const compareFilterAName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.baseQueryName || DEFAULT_COMPARE_FILTER_A_NAME,
  );
  const compareFilterBName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.deltaQueryName || DEFAULT_COMPARE_FILTER_B_NAME,
  );

  if (!compareTo?.whereClause) {
    return null;
  }

  if (compareField === 'A') {
    const isWhereClauseAEmpty =
      !whereClauseA || isEmptyWhereClause(whereClauseA);

    return isWhereClauseAEmpty ? (
      <>No {compareFilterAName} applied</>
    ) : (
      <WhereClausePreview
        shouldHideTooltips={shouldHideTooltips}
        whereClause={whereClauseA}
        sxProps={{
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.8),
        }}
      />
    );
  }

  const isWhereClauseBEmpty = !!compareTo?.whereClause
    ? isEmptyWhereClause(compareTo?.whereClause)
    : true;

  return isWhereClauseBEmpty ? (
    <>No {compareFilterBName} applied</>
  ) : (
    <WhereClausePreview
      shouldHideTooltips={shouldHideTooltips}
      whereClause={compareTo?.whereClause}
      sxProps={{
        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.8),
      }}
    />
  );
};
